// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__19HfY","header":"MergedInvoice_header__1ZqyG"};